/**
 * Environment configuration
 * Safely access environment variables in browser context
 */

// Helper to safely get environment variable
const getEnvVar = (key: string, defaultValue: string = ''): string => {
  // For Create React App, use import.meta.env or window._env_
  if (typeof window !== 'undefined' && (window as any)._env_?.[key]) {
    return (window as any)._env_[key];
  }
  
  // Fallback for build-time injection
  return defaultValue;
};

export const ENV = {
  // API Configuration
  API_URL: getEnvVar('REACT_APP_API_URL', 'http://localhost:8090'),
  
  // MSAL Configuration
  CLIENT_ID: getEnvVar('REACT_APP_CLIENT_ID', 'default-client-id'),
  AUTHORITY: getEnvVar('REACT_APP_AUTHORITY', 'https://login.microsoftonline.com/common'),
  REDIRECT_URI: getEnvVar('REACT_APP_REDIRECT_URI', 
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000'),
  POST_LOGOUT_REDIRECT_URI: getEnvVar('REACT_APP_POST_LOGOUT_REDIRECT_URI',
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000'),
  
  // Environment detection
  IS_DEVELOPMENT: typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'),
  IS_PRODUCTION: typeof window !== 'undefined' && 
    window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1',
};

// Smart API URL detection based on current environment
export const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const { hostname, port, protocol, pathname } = window.location;
    
    // If served under /skillstree/ via nginx proxy, use relative path
    if (pathname.startsWith('/skillstree')) {
      return '/skillstree';
    }
    
    // If accessed via nginx proxy on port 8088
    if (port === '8088') {
      return '';
    }
    
    // Local development without nginx
    if ((hostname === 'localhost' || hostname === '127.0.0.1') && port === '3000') {
      return 'http://localhost:8090';
    }
    
    // Production - use same origin with /skillstree prefix
    return `${protocol}//${hostname}/skillstree`;
  }
  
  return ENV.API_URL;
};

export const isDevelopment = (): boolean => ENV.IS_DEVELOPMENT;
export const isProduction = (): boolean => ENV.IS_PRODUCTION;
